import Storage from "./storage.service";
import Settings from "./settings.service";
import ReactDOM from "react-dom";
import { getLatLngKey } from "./helpers";
import GENERAL_MAP_PIN from "../assets/img/new_onboarding/pin@2x.png";

import { BehaviorSubject } from "rxjs";

var loaded = false;
var loaded_obsrv = new BehaviorSubject(loaded);

let timer = null;
let instances = {};
let session_token = null;
let Maps = null;
let DirectionsDisplay = null;

let markers = {};
let bubbles = {};

// const long_press_ms = 500;
const click_press_ms = 300;

// const rerender = (id) => {
//   Maps.event.trigger(instances[id], "resize");
// };

const getLocalAddressComponent = (place) => {
  let city = "";

  let components_by_priority = [
    "premise",
    "neighborhood",
    "locality",
    "administrative_area_level_2",
    "administrative_area_level_1",
  ];

  if (place && place["address_components"]) {
    for (let component of place["address_components"]) {
      for (let prop of components_by_priority) {
        if (component.types.indexOf(prop) !== -1) {
          city = component["long_name"];
          break;
        }
      }
      if (city) {
        break;
      }
    }
  }

  return city;
};

const addBubble = (map_id, text) => {
  let infoWindow = new Maps.InfoWindow();
  infoWindow.setContent(text);
  if (instances[map_id]) {
    bubbles[map_id] = infoWindow;
  }
};
const updateBubble = (map_id, text) => {
  bubbles[map_id].setContent(text);
};
const addLocationButton = (map_id) => {
  const locationButton = document.createElement("button");
  locationButton.textContent = "";
  locationButton.classList.add("custom-map-control-button");
  locationButton.classList.add("gm-control-active");
  locationButton.classList.add("gm-location-control");
  instances[map_id].controls[Maps.ControlPosition.TOP_RIGHT].push(
    locationButton,
  );

  locationButton.addEventListener("click", () => {
    Storage.set("ok_to_locate", true);
    locateUser(map_id);
  });
};

const mapExists = (map_id) => {
  if (instances[map_id]) {
    return true;
  }
  return false;
};

const findPlace = (map_id, latLng, panTo = false) => {
  if (Storage.get(map_id + "_" + getLatLngKey(latLng))) {
    let place = Storage.get(map_id + "_" + getLatLngKey(latLng));
    setLastPlace(map_id, place);
    if (instances[map_id] && panTo) {
      instances[map_id].panTo(latLng); // only for user location
      instances[map_id].setZoom(15);
    }
  } else {
    let geocoder = new Maps.Geocoder();
    geocoder.geocode(
      {
        latLng: latLng,
      },
      function (results, status) {
        if (status === Maps.GeocoderStatus.OK) {
          if (results[0]) {
            let place = results[0];

            let modifiedLatLng = {
              lat: place.geometry.location.lat,
              lng: place.geometry.location.lng,
            };
            Storage.set(
              "coverage_map_formatted_address",
              place.formatted_address,
              true,
            );
            Storage.set(map_id + "_" + getLatLngKey(modifiedLatLng), place);
            Storage.set(map_id + "_" + getLatLngKey(latLng), place);
            setLastPlace(map_id, place);
            if (instances[map_id] && panTo) {
              instances[map_id].panTo(latLng); // only for user location
              instances[map_id].setZoom(15);
            }
          }
        }
      },
    );
  }
};

const createMapListener = (id) => {
  // let pressTimer;

  let clickTimer;

  // instances[id].addListener("mousedown", function(e) {
  //   pressTimer = window.setTimeout(function() {

  //   }, Maps.long_press_ms);
  // });

  // instances[id].addListener("mouseup", function(e) {
  //   clearTimeout(pressTimer);
  // });

  instances[id].addListener("click", function (e) {
    // If the event has a placeId, use it.
    if (isIconMouseEvent(e)) {
      // Calling e.stop() on the event prevents the default info window from showing.
      // If you call stop here when there is no placeId you will prevent some
      // other map click event handlers from receiving the event.
      e.stop();

      // if (event.placeId) {
      //   this.calculateAndDisplayRoute(event.placeId);
      //   this.getPlaceInformation(event.placeId);
      // }
    }

    clickTimer = window.setTimeout(function () {
      let latLng = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      findPlace(id, latLng);

      // instances[id].panTo(e.latLng); // disabled by request
    }, click_press_ms);
  });

  instances[id].addListener("dblclick", function (e) {
    clearTimeout(clickTimer);
    let current_zoom = instances[id].getZoom();
    instances[id].setZoom(current_zoom + 1);
  });
};

const isIconMouseEvent = (e) => {
  return "placeId" in e;
};

const getLatLngFromPlace = (place) => {
  if (place && place.geometry) {
    let lat = place.geometry.location.lat;
    let lng = place.geometry.location.lng;

    if (typeof lat === "function") {
      lat = lat();
    }

    if (typeof lng === "function") {
      lng = lng();
    }

    let latLng = {
      lat: lat,
      lng: lng,
    };
    return latLng;
  }
  return null;
};

const setLastPlace = (map_id, place) => {
  let lat = place.geometry.location.lat;
  let lng = place.geometry.location.lng;

  if (typeof lat === "function") {
    lat = lat();
  }

  if (typeof lng === "function") {
    lng = lng();
  }

  let latlng = {
    lat: lat,
    lng: lng,
  };

  setMarker(latlng, map_id, "user_location");
  Storage.set("map_" + map_id + "_marker", latlng);
  Storage.set("map_" + map_id + "_last_place", place);
};

const setCenter = (map_id, latlng, zoom = null) => {
  let latLng = new Maps.LatLng(latlng.lat, latlng.lng);

  // shift map pin to the bottom 550 meters,
  // so added popup can be shown without overlap,
  // only shift on coverage confirm page:
  if (window.location.href.includes("coverage-confirm")) {
    var earth = 6378.137, //radius of the earth in kilometer
      pi = Math.PI,
      m = 1 / (((2 * pi) / 360) * earth) / 1000; //1 meter in degree
    var new_latitude = latlng.lat + 550 * m;
    latLng = new Maps.LatLng(new_latitude, latlng.lng);
  }

  instances[map_id].setCenter(latLng);
  if (zoom) {
    instances[map_id].setZoom(zoom);
  }
};

const createMap = (map_id, mapRef, options = null) => {
  let node = ReactDOM.findDOMNode(mapRef?.current);

  // clearMarkers(map_id); caused bugs

  let center = new Maps.LatLng(
    Settings.map_center_lat,
    Settings.map_center_lng,
  );

  let config = {
    mapId: "45d2fa3bb252fe30",
    zoom: 10,
    minZoom: 2,
    // clickableIcons: false, // disable points of interest icons
    center: center,
    mapTypeControl: true,
    navigationControl: true,
    streetViewControl: false,
    fullscreenControl: true,
    // fullscreenControlOptions: {
    //   position: Maps.ControlPosition.LEFT_TOP,
    // },
    zoomControl: true,
    zoomControlOptions: {
      position: Maps.ControlPosition.RIGHT_TOP,
      bundled: false,
    },
    mapTypeId: Maps.MapTypeId.ROADMAP,
  };
  if (options && options["freeze"]) {
    config["draggable"] = false;
    config["scrollwheel"] = false;
    config["panControl"] = false;
    config["mapTypeControl"] = false;
    config["fullscreenControl"] = false;
    config["navigationControl"] = false;
    config["maxZoom"] = 15;
    config["minZoom"] = 15;
    config["zoom"] = 15;
    config["zoomControl"] = false;
    config["clickableIcons"] = false;
    config["gestureHandling"] = "none";
    config["doubleClickZoom"] = false; // Disable double-click zoom
    config["boxZoom"] = false; // Disable box zoom
    config["tap"] = false;
    config["keyboardShortcuts"] = false;
  }

  if (options && options["fullscreenControl"] === false) {
    config["fullscreenControl"] = false;
  }
  if (options && options["navigationControl"] === false) {
    config["navigationControl"] = false;
  }
  if (options && options["mapTypeControl"] === false) {
    config["mapTypeControl"] = false;
  }

  if (node) {
    config[map_id] = config;

    let drawSaved = null;

    let map = new Maps.Map(node, config[map_id]);
    DirectionsDisplay.setMap(map);
    map.bounds = new Maps.LatLngBounds();

    if (!markers[map_id]) {
      markers[map_id] = {};
    }

    let latLng = null;

    if (options && options.marker) {
      latLng = options.marker;
    } else {
      let place = Storage.get("map_" + map_id + "_last_place");

      let lat = null;
      let lng = null;
      if (place) {
        if (place.geometry) {
          lat = place.geometry.location.lat;
          lng = place.geometry.location.lng;
        } else {
          lat = place.lat;
          lng = place.lng;
        }
        if (typeof lat === "function") {
          lat = lat();
          lng = lng();
        }

        latLng = {
          lat: lat,
          lng: lng,
        };
      }
    }

    if (latLng) {
      drawSaved = () => {
        let marker_name = "user_location";
        setMarker(latLng, map_id, marker_name, options);

        if (options && options["freeze"]) {
          setCenter(map_id, latLng);
        }
      };
    } else {
      Storage.clear("map_" + map_id + "_marker");
      Storage.clear("map_" + map_id + "_last_place");
      clearMarkers(map_id);
    }

    instances[map_id] = map;

    if (!(options && options["freeze"])) {
      createMapListener(map_id);
    }

    if (
      !(options && (options["freeze"] || options["locationButton"] === false))
    ) {
      addLocationButton(map_id);
    }

    setTimeout(() => {
      if (drawSaved) {
        drawSaved();
      }
    }, 1000);

    return instances[map_id];
  }
  return null;
};

const createPin = (map_id, latlng, name, html, options = null) => {
  let pin_image = GENERAL_MAP_PIN;
  if (options && options["pin_image"]) {
    pin_image = options["pin_image"];
  }
  const content = document.createElement("div");
  content.style.backgroundImage = `url(${pin_image})`;
  content.style.width = `68px`;
  content.style.height = `68px`;
  content.style.backgroundSize = "contain";
  content.style.backgroundRepeat = "no-repeat";

  let marker = new Maps.marker.AdvancedMarkerElement({
    position: latlng,
    map: instances[map_id],
    content: content,
    zIndex: Math.round(latlng.lat * -100000) << 5,
    title: options?.name ? options.name : name,
  });
  if (
    map_id === "CoverageMap" &&
    window.location.href.includes("coverage-map")
  ) {
    adjustMapForInfoWindow(instances[map_id], marker, bubbles[map_id]);
  }
  return marker;
};

const clearMarkers = (map_id) => {
  if (markers && markers[map_id]) {
    let marker_ids = Object.keys(markers[map_id]);
    for (let marker_id of marker_ids) {
      markers[map_id][marker_id].setMap(null);
    }
    markers[map_id] = {};
  }
};

const setMarker = (latLng, map_id, marker_id, options = null) => {
  if (!markers[map_id]) {
    markers[map_id] = {};
  }
  if (latLng) {
    clearMarkers(map_id);
    markers[map_id][marker_id] = createPin(
      map_id,
      latLng,
      "name",
      "<b>Location</b><br>" + latLng.lat + ", " + latLng.lng,
      options,
    );
  }

  if (!(options && options["freeze"]) && bubbles[map_id]) {
    bubbles[map_id].setPosition(latLng);
    bubbles[map_id].open(instances[map_id]);
  }
};

const locateUser = (map_id) => {
  Storage.set("ok_to_locate", true);
  if (navigator.geolocation && !Storage.get("fetchingCurrentPosition")) {
    Storage.set("fetchingCurrentPosition", true);
    // let d = new Date();
    // log("Fetching location started at :");
    // log(d.toLocaleTimeString());

    navigator.geolocation.getCurrentPosition(
      function (position) {
        // log("Success: fetching location");
        Storage.set("fetchingCurrentPosition", false);

        if (Storage.get("ok_to_locate")) {
          let latLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          findPlace(map_id, latLng, true);
        }
      },
      function () {
        // log("error: fetching location");
        Storage.set("fetchingCurrentPosition", false);
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      },
    );
  }
};

const displaySuggestions = (namespace, predictions, status) => {
  if (status !== Maps.places.PlacesServiceStatus.OK) {
    Storage.clear(namespace + "_autocomplete_predictions");
    return;
  }
  Storage.set(namespace + "_autocomplete_predictions", predictions);
};

const clearSuggestions = (namespace) => {
  Storage.clear(namespace + "_autocomplete_predictions");
};

const fetchPlaceDetails = (map_id, place_id) => {
  let map = instances[map_id];
  let request = {
    placeId: place_id,
    fields: ["formatted_address", "geometry", "name", "address_components"],
  };

  let service = new Maps.places.PlacesService(map);

  service.getDetails(request, (place, status) => {
    if (status === Maps.places.PlacesServiceStatus.OK) {
      // set address
      setLastPlace(map_id, place);
    }
  });
  generateMapsSessionUUID();
};

const fetchPlacePredictions = (namespace, search_term = null) => {
  if (search_term) {
    let service = new Maps.places.AutocompleteService();
    let request = {
      input: search_term,
      //fields: ['geometry', 'formatted_address'],
      sessiontoken: getMapsSessionUUID(),
      componentRestrictions: { country: "ae" },
    };
    service.getPlacePredictions(request, (predictions, status) => {
      displaySuggestions(namespace, predictions, status);
    });
  } else {
    Storage.clear(namespace + "_autocomplete_predictions");
  }
};

const getMapsSessionUUID = () => {
  if (!session_token) {
    generateMapsSessionUUID();
  }
  return session_token;
};

const generateMapsSessionUUID = () => {
  session_token = Storage.get("session") + Date.now();
  return session_token;
};

const addSearch = (searchRef, map_id) => {
  // Create the search box and link it to the UI element.
  var input = searchRef.current;

  // var container = document.getElementById('map_search');
  var searchBox = new Maps.places.SearchBox(input);
  // dis.map.controls[dis.maps.ControlPosition.BOTTOM_LEFT].push(container);

  instances[map_id].addListener("bounds_changed", function () {
    searchBox.setBounds(instances[map_id].getBounds());
  });

  searchBox.addListener("places_changed", function () {
    var places = searchBox.getPlaces();

    if (places.length === 0) {
      return;
    }

    // For each place, get the icon, name and location.

    var bounds = new Maps.LatLngBounds();
    places.forEach(function (place) {
      if (!place.geometry) {
        return;
      }

      let lat = place.geometry.location.lat;
      let lng = place.geometry.location.lng;

      if (typeof lat === "function") {
        lat = lat();
      }

      if (typeof lng === "function") {
        lng = lng();
      }

      let latlng = {
        lat: lat,
        lng: lng,
      };
      setMarker(latlng, map_id, "user_location");
      Storage.set("map_" + map_id + "_marker", latlng);
      Storage.set("map_" + map_id + "_last_place", place);
      Storage.set(
        "coverage_map_formatted_address",
        place.formatted_address,
        true,
      );
      if (place.geometry.viewport) {
        // Only geocodes have viewport.
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });

    instances[map_id].fitBounds(bounds);

    Storage.set("fetchingCurrentPosition", false);
  });
};

const loadGoogleMaps = () => {
  if (!document.getElementById("gmaps")) {
    let src =
      "https://maps.googleapis.com/maps/api/js?key=" +
      Settings.google_maps_app_id +
      "&loading=async&language=en" +
      "&libraries=places,marker&callback=mapLoaded";

    var ref = window.document.getElementsByTagName("script")[0];
    var script = window.document.createElement("script");
    script.src = src;
    script.id = "gmaps";
    script.async = true;
    ref.parentNode.insertBefore(script, ref);

    timer = setInterval(() => {
      if (
        document.getElementById("gmaps") &&
        window.google &&
        window.google.maps
      ) {
        clearInterval(timer);
        Maps = window.google.maps;
        DirectionsDisplay = new Maps.DirectionsRenderer();

        Storage.setShared("maps_loaded", true);

        loaded_obsrv.next(true);
        loaded_obsrv.complete();
      }
    }, 2000);
  } else {
    loaded_obsrv.next(true);
    loaded_obsrv.complete();
  }
  return loaded_obsrv;
};
const coordinates_to_address = async (latLng) => {
  if (!latLng) {
    return;
  }
  let geocoder = new Maps.Geocoder();
  let formatted_address = await geocoder.geocode(
    { latLng: latLng },
    function (results, status) {
      if (status === Maps.GeocoderStatus.OK) {
        if (results[1]) {
          return results[1].formatted_address;
        }
      }
    },
  );

  return formatted_address;
};

const adjustMapForInfoWindow = (map, marker, infoWindow) => {
  map.setZoom(12);
  // Get the position directly from the marker
  const markerPosition = marker.position;
  // Pan the map to the marker position
  map.panTo(markerPosition);
  // Open the InfoWindow
  infoWindow.open({
    map: map,
    anchor: marker,
  });
};
window.mapLoaded = () => {};

export {
  findPlace,
  mapExists,
  getLatLngFromPlace,
  addLocationButton,
  loadGoogleMaps,
  createMap,
  addSearch,
  getLocalAddressComponent,
  clearSuggestions,
  locateUser,
  fetchPlacePredictions,
  fetchPlaceDetails,
  addBubble,
  updateBubble,
  coordinates_to_address,
};
